import {
  type CoviViewRegistry,
  type CoviViewSnapshot,
} from "./viewContextDeclaration"
import { createCoviViewRegistry } from "./viewContextRegistry"

export {
  COVI_EDITOR_ATTRIBUTE,
  COVI_LIST_FILTERS_ATTRIBUTE,
  COVI_LIST_SEARCH_ATTRIBUTE,
  COVI_LIST_SHOWING_ATTRIBUTE,
  COVI_LIST_SORT_ATTRIBUTE,
  COVI_LIST_TOTAL_ATTRIBUTE,
  COVI_ROW_ANCHOR_ATTRIBUTE,
  COVI_ROW_NAME_ATTRIBUTE,
  COVI_ROW_STATUS_ATTRIBUTE,
  COVI_VIEW_ATTRIBUTE,
  COVI_VIEW_KINDS,
  COVI_VIEW_LIST_ATTRIBUTE,
  parseCoviEditorDeclaration,
  parseCoviViewDeclaration,
} from "./viewContextDeclaration"
export type {
  CoviFocusStackEntry,
  CoviIntersectionChange,
  CoviIntersectionObserverLike,
  CoviViewEditorState,
  CoviViewEnvelope,
  CoviViewKind,
  CoviViewListMeta,
  CoviViewPrimary,
  CoviViewRegistry,
  CoviViewSelection,
  CoviViewSnapshot,
  CoviViewVisibleRow,
  CreateCoviViewRegistryOptions,
} from "./viewContextDeclaration"
export { createCoviViewRegistry } from "./viewContextRegistry"

/**
 * The per-browser-tab registry instance. Started once from `CoviMount` (via
 * `useCoviViewObserver`) so it survives navigation; shared by all chat threads.
 */
export const coviViewRegistry: CoviViewRegistry = createCoviViewRegistry()

/** Capture the current send-time view context without throwing. */
export function snapshotCoviViewContext(): CoviViewSnapshot {
  return coviViewRegistry.snapshot()
}
